export const state = {
  user: null,
  showSidebar: false,
}

export const mutations = {
  setUser(state, user){ state.user = user; },

  toggleSidebar(state, showSidebar){
    state.showSidebar = !state.showSidebar;
  },

  hideSidebar(state, showSidebar){
    state.showSidebar = false;
  }
}



// WEBPACK FOOTER //
// ./src/store/state.js